"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CONTRACTS = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.GET_CONTRACTS = (0, gql_1.gql)(`
  query contracts(
    $projectId: ID!,
    $optionsToCheck: [String!]!,
  ) {
    projects(ids: [$projectId]) {
      edges {
        node {
          id
          contracts(first: 1) {
            edges {
              node {
                id
                terms
                allowedOptions(options: $optionsToCheck)
              }
            }
          }
        }
      }
    }
  }
`);
